// Maximum number of concurrent image download slots
export const IMAGE_DOWNLOAD_SLOT_COUNT = 6;

export const DOWNLOAD_IMAGES_TAB_PARAM = 'tab';

export const DOWNLOAD_IMAGES_TABS = {
  select: 'select',
  download: 'download',
} as const;
